import { ApiPermission, FeatureFlags, OrganizationPermission, ClientPermission } from '../enums/generated.enums';
import { ModuleType, PageType, SubPageType } from '../enums/page-type.enum';

export class PermissionHelper {
  static get clientPermissions(): ClientPermission[] {
    return Object.keys(ClientPermission) as ClientPermission[];
  }

  static get apiPermissions(): ApiPermission[] {
    return Object.keys(ApiPermission) as ApiPermission[];
  }

  static get organizationPermissions(): OrganizationPermission[] {
    return [
      OrganizationPermission.Monitoring,
      OrganizationPermission.Orchestration,
      OrganizationPermission.OrchestrationSettings,
      OrganizationPermission.Simulator,
      OrganizationPermission.SimulatorSettings,
      OrganizationPermission.Analytics,
      OrganizationPermission.AnalyticsSettings,
      OrganizationPermission.RuntimeAnalysis,
      OrganizationPermission.Reporting,
      OrganizationPermission.ReportingSettings,
      OrganizationPermission.Benchmarking,
      OrganizationPermission.BenchmarkingSettings,
      OrganizationPermission.MetricAlerts,
      OrganizationPermission.IncidentDetection,
      OrganizationPermission.FastAnomalyDetection,
      OrganizationPermission.AiAgent,
    ];
  }

  static get apiKeyPermissions(): ApiPermission[] {
    return [
      ApiPermission.Import,
      ApiPermission.OrchestrationWebhooks,
      ApiPermission.UiPathWebhooks,
    ];
  }

  static getPagePermission(module: ModuleType, page: PageType, subPage?: SubPageType): ClientPermission {
    switch (module) {
      case ModuleType.Monitoring:
        return ClientPermission.Monitoring;
      case ModuleType.Orchestration:
        switch (page) {
          case PageType.AuditLog:
            return ClientPermission.AuditLog;
          default:
            return ClientPermission.Orchestration;
        }
      case ModuleType.Analytics:
        switch (page) {
          case PageType.RuntimeAnalysis:
            return ClientPermission.RuntimeAnalysis;
          case PageType.Anomalies:
            return ClientPermission.FastAnomalyDetection;
          case PageType.DetectedIncidents:
            return ClientPermission.IncidentDetection;
          default:
            return ClientPermission.Analytics;
        }
      case ModuleType.Reporting:
        switch (page) {
          case PageType.ProcessReporting:
            return ClientPermission.ProcessReporting;
          case PageType.BenchmarkOverview:
            return ClientPermission.Benchmarking;
          default:
            return ClientPermission.Reporting;
        }
      case ModuleType.Workflows: {
        return ClientPermission.Monitoring;
      }
      case ModuleType.Settings: {
        switch (subPage) {
          case SubPageType.GeneralSettings:
            return ClientPermission.GeneralSettings;
          case SubPageType.TenantsSettings:
            return ClientPermission.TenantsSettings;
          case SubPageType.ProcessesSettings:
            return ClientPermission.ProcessesSettings;
          case SubPageType.ResourcesSettings:
            return ClientPermission.ResourcesSettings;
          case SubPageType.QueuesSettings:
            return ClientPermission.QueuesSettings;
          case SubPageType.UsersSettings:
            return ClientPermission.UsersSettings;
          case SubPageType.NotificationsSettings:
            return ClientPermission.NotificationsSettings;
          case SubPageType.ApiCredentialsSettings:
            return ClientPermission.ApiCredentialsSettings;
          case SubPageType.AiProvidersSettings:
            return ClientPermission.AiProvidersSettings;
          case SubPageType.AnomaliesSettings:
            return ClientPermission.AnomaliesSettings;
          case SubPageType.ExternalServicesSettings:
            return ClientPermission.ExternalServicesSettings;
          case SubPageType.ConditionStates:
            return ClientPermission.ConditionStates;
          case SubPageType.PendingSessions:
            return ClientPermission.PendingSessions;
          case SubPageType.OrchestrationDebugging:
            return ClientPermission.OrchestrationDebugging;
          case SubPageType.ReportingSettings:
            return ClientPermission.ReportingSettings;
          case SubPageType.BusinessProcessesSettings:
            return ClientPermission.BusinessProcessesSettings;
          case SubPageType.SavingsSettings:
            return ClientPermission.SavingsSettings;
          case SubPageType.GroupsSettings:
            return ClientPermission.DomainsSettings;
          case SubPageType.BillingGroupsSettings:
            return ClientPermission.BillingGroupsSettings;
          case SubPageType.BenchmarkingSettings:
            return ClientPermission.BenchmarkingSettings;
          case SubPageType.ImportExportSettings:
            return ClientPermission.ImportExportSettings;
          default:
            return ClientPermission.OrganizationSettings;
        }
      }
      case ModuleType.Admin:
        return ClientPermission.SystemAdmin;
      case ModuleType.RpaNotConnected:
        return ClientPermission.Monitoring;
      default:
        return null;
    }
  }

  static getPageFeatureFlag(module: ModuleType, page: PageType, subPage?: SubPageType): FeatureFlags {
    if (module === ModuleType.Workflows) {
      return FeatureFlags.Workflows;
    }
    if (subPage === SubPageType.DumpViewer) {
      return FeatureFlags.DumpViewer;
    }
    if (subPage === SubPageType.MsTeamsSettings) {
      return FeatureFlags.MsTeamsIntegration;
    }
    if (subPage === SubPageType.AiProvidersSettings) {
      return FeatureFlags.Workflows;
    }

    return null;
  }
}
